var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import history from "@ane/core/lib/CreateHistory";
import { combineEpics } from "redux-observable";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { createSelector } from "reselect";
import { matchesRootPathname } from "@ane/exp-data/lib/routes/Route.utils";
import { IsolationGroupRouteUtils } from "@ane/exp-data/lib/routes/IsolationGroupRoute.utils";
const IG_LIST_DELIMETER = ",";
const fromSearchContext = (searchContext) => ({
  isolationGroupIds: searchContext.isolationGroupIds.split(IG_LIST_DELIMETER).filter((id) => !!id),
  experimentationGroup: searchContext.experimentationGroup,
  audienceFilterExpressions: searchContext.audienceFilterExpression ? [searchContext.audienceFilterExpression] : []
});
const toSearchContext = (trafficUsageRequest) => {
  var _a, _b, _c, _d;
  return {
    isolationGroupIds: (_b = (_a = trafficUsageRequest.isolationGroupIds) == null ? void 0 : _a.join(IG_LIST_DELIMETER)) != null ? _b : "",
    experimentationGroup: (_c = trafficUsageRequest.experimentationGroup) != null ? _c : "",
    audienceFilterExpression: trafficUsageRequest.audienceFilterExpressions && ((_d = trafficUsageRequest.audienceFilterExpressions) == null ? void 0 : _d.length) > 0 ? trafficUsageRequest.audienceFilterExpressions[0] : ""
  };
};
const toPartialSearchContext = (trafficUsageRequest) => {
  const searchContext = {};
  if (trafficUsageRequest.isolationGroupIds) {
    searchContext.isolationGroupIds = trafficUsageRequest.isolationGroupIds.join(IG_LIST_DELIMETER);
  }
  if (trafficUsageRequest.experimentationGroup) {
    searchContext.experimentationGroup = trafficUsageRequest.experimentationGroup;
  }
  if (trafficUsageRequest.audienceFilterExpressions && trafficUsageRequest.audienceFilterExpressions.length > 0) {
    searchContext.audienceFilterExpression = trafficUsageRequest.audienceFilterExpressions[0];
  }
  return searchContext;
};
const actionTypes = {
  SET_CONTEXT: "IG_CAPACITY/SET_CONTEXT",
  SET_PARTIAL_CONTEXT: "IG_CAPACITY/SET_PARTIAL_CONTEXT"
};
const setCapacitySearchContext = (context) => ({
  type: actionTypes.SET_CONTEXT,
  payload: context
});
const setPartialCapacitySearchContext = (context) => ({
  type: actionTypes.SET_PARTIAL_CONTEXT,
  payload: context
});
const setCapacitySearchContextFromTrafficUsageRequest = (trafficUsageRequest) => setCapacitySearchContext(toSearchContext(trafficUsageRequest));
const setPartialCapacitySearchContextFromTrafficUsageRequest = (trafficUsageRequest) => setPartialCapacitySearchContext(toPartialSearchContext(trafficUsageRequest));
const selectCapacitySearchContext = (state) => state.isolation_group_app_module.capacity.searchContext;
const selectTrafficUsageRequestFromSearchContext = createSelector(
  [selectCapacitySearchContext],
  (urlContext) => fromSearchContext(urlContext)
);
const capacitySearchUserContext = {
  isolationGroupIds: {
    paramType: "string",
    isMultiValue: true,
    defaultValue: ""
  },
  audienceFilterExpression: {
    paramType: "string",
    isMultiValue: true,
    defaultValue: ""
  },
  experimentationGroup: {
    paramType: "string",
    defaultValue: ""
  }
};
const produceCapacitySearchContextRouteQueryStringSyncEpics = (history2) => {
  const setCapacitySearchContextFromQueryString = produceUserContextRouteQueryStringEpics(
    capacitySearchUserContext,
    setCapacitySearchContext,
    actionTypes.SET_PARTIAL_CONTEXT,
    actionTypes.SET_CONTEXT,
    selectCapacitySearchContext,
    history2,
    (pathname) => {
      return matchesRootPathname(pathname, IsolationGroupRouteUtils.routes.root.path());
    },
    EXP_QUERY_STRINGS
  );
  return combineEpics(
    setCapacitySearchContextFromQueryString.setQueryStringFromUserContext,
    setCapacitySearchContextFromQueryString.setUserContextFromPartial,
    setCapacitySearchContextFromQueryString.setUserContextFromQueryString
  );
};
const capacitySearchContextEpics = produceCapacitySearchContextRouteQueryStringSyncEpics(history);
const capacitySearchContextReducer = (state = {
  searchContext: { isolationGroupIds: "", experimentationGroup: "", audienceFilterExpression: "" }
}, action) => {
  switch (action.type) {
    case actionTypes.SET_CONTEXT:
      return __spreadProps(__spreadValues({}, state), {
        searchContext: action.payload
      });
    case actionTypes.SET_PARTIAL_CONTEXT:
      return __spreadProps(__spreadValues({}, state), {
        searchContext: __spreadValues(__spreadValues({}, state.searchContext), action.payload)
      });
    default:
      return state;
  }
};
export {
  capacitySearchContextEpics,
  capacitySearchContextReducer,
  capacitySearchUserContext,
  selectCapacitySearchContext,
  selectTrafficUsageRequestFromSearchContext,
  setCapacitySearchContext,
  setCapacitySearchContextFromTrafficUsageRequest,
  setPartialCapacitySearchContext,
  setPartialCapacitySearchContextFromTrafficUsageRequest
};
//# sourceMappingURL=CapacitySearchContext.js.map
